import { ColourVariant } from "@shared/ui.design-system"

export type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl"

export const sizeMap: Record<SpinnerSize, number> = {
  xs: 20,
  sm: 80,
  md: 120,
  lg: 160,
  xl: 200,
}

export type LoadingSpinnerProps = {
  size?: SpinnerSize
  colour?: ColourVariant
}
